import { useQuery } from '@tanstack/react-query';

import {
  getEmailByMessageId,
  type GetEmailByMessageIdResponse,
} from 'wg-api-sdk';

import wgApi from '@/lib/api/wgApi';
import type { QueryOptions } from '@/types/react-query';

import queryKeys from '../queryKeys';

export default function useAnalyzedEmail(
  messageId: string,
  options?: QueryOptions<GetEmailByMessageIdResponse>,
) {
  return useQuery({
    queryKey: queryKeys.byMessageId(messageId),
    queryFn: () =>
      getEmailByMessageId({ query: { message_id: messageId } }, wgApi),
    ...options,
  });
}
